import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export async function downloadPdf(endpoint: string, filename: string) {
  try {
    const token = localStorage.getItem('maluz_access_token');
    const response = await axios.get(`${API}${endpoint}`, {
      responseType: 'blob',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error('PDF download failed:', err);
    alert('Failed to download PDF. Please try again.');
  }
}
